// ui-library
import { boxShadow, color } from '@upstox/upstox-ui';
import { fonts } from '@upstox/upstox-ui/theme/light/fonts';

export const modalContainer: CSSFunction = () => ({
  position: 'absolute',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  fontFamily: fonts.tvFont,
});

export const modalDialog: CSSFunction = ({ theme }) => ({
  zIndex: 2,
  background: color(theme, theme.modals.backgroundBackdrop),
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
});

export const base: CSSFunction = ({ theme }) => ({
  zIndex: 3,
  backgroundColor: color(theme, theme.colors.background.default4),
  boxShadow: boxShadow(theme, theme.modals.boxShadow),
  margin: 'auto',
  width: '720px',
  position: 'absolute',
  lineHeight: '20px',
  transform: 'translate(0, 0)',
  borderRadius: 8,
});

export const modalHeader: CSSFunction = ({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 18,
  borderBottom: `${color(theme, theme.colors.ui3)} solid 1px`,
  fontSize: 21,
  fontWeight: 600,
  color: color(theme, theme.colors.text[1]),
});

export const modalBody: CSSFunction = ({ theme }) => ({
  padding: 24,
  paddingBottom: 16,
  overflow: 'scroll',
  borderBottom: `${color(theme, theme.colors.ui3)} solid 1px`,
});

export const modalFooter: CSSFunction = () => ({
  padding: '16px 24px',
});

export const contentContainer: CSSFunction = ({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  height: '100%',
  fontSize: 14,
  fontWeight: 400,
  color: color(theme, theme.colors.text[2]),

  '& ul,ol': {
    margin: '0px 8px',
    padding: '0px 8px',
    listStyleType: 'disc',
  },
  '& li:not(:last-child)': {
    marginBottom: '8px',
  },
});
